import React from "react";
import "./Component.css";

const ApiLink = (props) => {
  let name = props.apiLinkData.client_name;
  let apiLink = props.apiLinkData.openapi_json;
  let postmanLink= props.apiLinkData.postman_collectionv2;
  let id = props.apiLinkData.id;
  let createdBy = props.apiLinkData.created_by;
  let createdOn = props.apiLinkData.last_modified_on;

  function handleClick() {
    props.updateDefinitionLink(apiLink, postmanLink, id, apiLink, postmanLink, createdBy, createdOn);
  }


  return (
    <div className="api-link" onClick={() => handleClick()}>
      {name}
    </div>
  );
};

export default ApiLink;
